exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(min-width:1025px){.benutzerverwaltung-view{width:1400px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/benutzerverwaltung/benutzerverwaltung.module.scss
// module id = kwWi
// module chunks = 0